import React, { useEffect } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

const SearchBar = ({
  handleSearch,
  counter,
  location,
  onChangeLocation,
  search,
  setSearch,
  placeholder,
  autoSearch,
}) => {
  useEffect(() => {
    let timer;
    if (autoSearch) {
      timer = setTimeout(() => {
        if (search !== null) handleSearch(search);
      }, 500);
    }
    if (timer) return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleChange = (e) => setSearch(e.target.value);
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch(search);
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        placeholder={placeholder}
        className={`block w-full h-9 rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 ${
          counter > 0 ? 'pl-[110px]' : ''
        }`}
        value={search || ''}
        onChange={handleChange}
        onKeyDown={handleKeyPress}
      />
      {counter > 0 && (
        <div className="absolute left-2 top-1/2 -translate-y-1/2 z-20 flex items-center gap-1 text-xs text-slate-500">
          {counter > 1 && (
            <>
              <button
                type="button"
                aria-label="Next match"
                className="rounded-sm hover:bg-slate-100 p-0.5"
                onClick={() => onChangeLocation('down')}
              >
                <IoIosArrowDown className="h-4 w-4" />
              </button>
              <button
                type="button"
                aria-label="Previous match"
                className="rounded-sm hover:bg-slate-100 p-0.5"
                onClick={() => onChangeLocation('up')}
              >
                <IoIosArrowUp className="h-4 w-4" />
              </button>
            </>
          )}
          <span className="font-mono tabular-nums">{`${location}/${counter}`}</span>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
